
function updateAfterpayWidget(price) {

    const cartTotal = price;

    const afterpayElement = document.querySelector('afterpay-placement');
    if (afterpayElement) {
      afterpayElement.setAttribute('data-amount', cartTotal.toString());
      
      afterpayElement.style.display = '';
      
      const afterpayContainer = afterpayElement.closest('.afterpay-cart-section, .cart-afterpay-wrapper');
      if (afterpayContainer) {
        afterpayContainer.style.display = '';
        afterpayContainer.classList.remove('hidden');
        afterpayContainer.classList.remove('hide');
      }
      
      document.querySelectorAll('.cart-drawer__footer, .drawer__footer').forEach(footer => {
        if (footer) {
          footer.style.display = '';
          footer.classList.remove('hidden');
          footer.classList.remove('hide');
        }
      });
      
      // Reinitialize the widget if available
      if (window.Afterpay) {
        window.Afterpay.initializeElements();
      }
    }
  }
  
  function refreshCart(){
    setTimeout(() => {
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const price = cart.total_price / 100;

            updateAfterpayWidget(price);
  
          // Dispatch standard events
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        })
        .catch(error => console.error('Error refreshing cart:', error));
        }, 2000);
  
  }
  
  document.addEventListener('submit', function(event) {
      const form = event.target;
      if (form.action && form.action.includes('/cart/add')) {
          refreshCart();
        
      }
    });
   
    refreshCart(); 
  //document.addEventListener('cart:updated', refreshCart);
  //document.addEventListener('cart:refresh', refreshCart);